var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotConnected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_1313_133884)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1313_133884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint1_linear_1313_133884)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1313_133884)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1313_133884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint2_linear_1313_133884)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1313_133884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.5 93.5566L128.488 96.5401L128.414 96.7573L128.202 96.8431L125.336 98L128.202 99.1569L128.414 99.2427L128.488 99.4599L129.5 102.443L130.512 99.4599L130.586 99.2427L130.798 99.1569L133.664 98L130.798 96.8431L130.586 96.7573L130.512 96.5401L129.5 93.5566Z",
    stroke: "#00517D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 45L23.1294 51.92L18.0718 57L25 55.16L31.9282 57L26.8706 51.92L25 45Z",
    fill: "#00517D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 48C120.255 48 141.824 50.717 155 72",
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 48C113 36.9543 104.046 28 93 28H61V68H93C104.046 68 113 59.0457 113 48Z",
    fill: "url(#paint3_linear_1313_133884)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 16.5,
    ry: 20,
    transform: "matrix(-1 0 0 1 61.5 48)",
    fill: "url(#paint4_linear_1313_133884)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 60 39.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 60 55)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6815 99.6553C55.2512 99.6553 41.978 95.3977 33.2982 103.967C22.2608 114.864 24.0093 123.938 31.2082 120.687C53.6031 110.573 23.1668 105.495 4.76562 121.234",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4307 100.574C44.4307 90.0072 52.9965 81.4414 63.5629 81.4414H95.5196V121.384H65.2407C53.7476 121.384 44.4307 112.067 44.4307 100.574Z",
    fill: "url(#paint5_linear_1313_133884)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2862,
    cy: 101.413,
    rx: 16.9522,
    ry: 19.9711,
    fill: "url(#paint6_linear_1313_133884)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4484,
    cy: 93.0524,
    r: 3.25111,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4484,
    cy: 108.379,
    r: 3.25111,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.6621,
    y: 90.2661,
    width: 20.9,
    height: 5.57333,
    rx: 2.78667,
    fill: "#004265"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.6621,
    y: 105.592,
    width: 20.9,
    height: 5.57333,
    rx: 2.78667,
    fill: "#004265"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1313_133884",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 191.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1313_133884",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CBD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1313_133884",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1313_133884",
    x1: 87,
    y1: 28,
    x2: 87,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACCFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1313_133884",
    x1: 32.8817,
    y1: 19.0815,
    x2: -0.112998,
    y2: 20.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21486C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5093E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1313_133884",
    x1: 69.9751,
    y1: 81.4414,
    x2: 69.9751,
    y2: 121.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#A2C6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1313_133884",
    x1: 111.816,
    y1: 102.873,
    x2: 78.8014,
    y2: 102.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1081BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5994E7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnected);
export default __webpack_public_path__ + "static/media/notConnected.a38f0c05634c47945a77285d56aabb06.svg";
export { ForwardRef as ReactComponent };